module.exports = __webpack_public_path__ + "img/zh_common.4bb1874c.png";